// extracted by mini-css-extract-plugin
export default {"pass":"FeedbackMessage_pass__u3XHK","fail":"FeedbackMessage_fail__XMMr+"};